/**
 * @description 查询轻应用应用能力
 * @param {string} appId 应用id
 * @param {'innerapp'|'isv'} type innerapp-0:自建应用，isv-2:第三方应用
 */
export const fetchWecodeAppInfo = (appId, type) => {
  return fetch(`/wecode/service/${type}/h5/ability/${appId}`, {
    method: "GET"
  });
};

/**
 * @description 删除轻应用能力
 * @param {string} appId 应用id
 * @param {'innerapp'|'isv'} type innerapp-0:自建应用，isv-2:第三方应用
 */
export const deleteWecodeAbility = (appId, type) => {
  return fetch(`/wecode/service/${type}/h5/ability/${appId}`, {
    method: "DELETE"
  });
};

/**
 * @description 配置轻应用能力，暂时只传中文地址
 * @param {object} param
 * @param {number} param.isSupportMobile
 * @param {number} param.isSupportPC
 * @param {number} param.isOpenSystemBrowser
 * @param {string} param.mobileUrlCn
 * @param {string} param.pcUrlCn
 * @param {string} param.manageUrlCn
 * @param {string} param.appId
 * @param {'innerapp'|'isv'} type innerapp-自建应用，isv-第三方应用
 */
export const updateWecodeAppInfo = (param, type) => {
  return fetch(`/wecode/service/${type}/h5/ability/${param.appId}`, {
    method: "PUT",
    body: JSON.stringify(param)
  });
};
